export default __webpack_public_path__ + "static/media/flutter.04e47540.svg";